// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QRbRgklCyKYJdI5XeWlE{display:flex;gap:10px;width:80vw;min-height:200px;max-height:550px;height:80vh;min-width:300px;max-width:1000px;white-space:pre-wrap}.QRbRgklCyKYJdI5XeWlE img{width:100%}.QRbRgklCyKYJdI5XeWlE .NKdqCUDxUjjsuyVfH65j{font-size:10px;color:#8496b9}.QRbRgklCyKYJdI5XeWlE .Kh2dxDSIWsqi5QeLymdl{width:40%;min-width:300px;font-size:12px;margin-bottom:2rem}.QRbRgklCyKYJdI5XeWlE .pVHp4BZW5ApCSv522TbE{font-size:1.5rem;font-weight:bold;margin-top:0;margin-bottom:1rem;color:#6e32f0}.QRbRgklCyKYJdI5XeWlE .fKNtSYdXC8QVbOdQTxHV{font-size:1rem;line-height:1.5}.QRbRgklCyKYJdI5XeWlE .E4VgqCTciPXae8CI2l87{display:flex;justify-content:center;align-items:center}.QRbRgklCyKYJdI5XeWlE .GG7u5JzVE337HMrLvcGy{height:100%;background-color:#e5e5e5;margin:1rem;width:2px}.QRbRgklCyKYJdI5XeWlE p{font-size:12px !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"slide": `QRbRgklCyKYJdI5XeWlE`,
	"imgDescription": `NKdqCUDxUjjsuyVfH65j`,
	"content": `Kh2dxDSIWsqi5QeLymdl`,
	"title": `pVHp4BZW5ApCSv522TbE`,
	"description": `fKNtSYdXC8QVbOdQTxHV`,
	"imageContainer": `E4VgqCTciPXae8CI2l87`,
	"divider": `GG7u5JzVE337HMrLvcGy`
};
export default ___CSS_LOADER_EXPORT___;
